import { html } from 'fxjs/es';

export const makeItemHtml = (product) => {
  console.log(product);
  return html``;
};
